import { StepActivationId } from '../../BrandedIds';
import { Actor } from '../../events/BaseLoanEvent';
import { Temporal } from '../../Temporal';

export interface SerializedFormSubmission {
  submission: Record<string, unknown>;
  submittedAt: Temporal.ZonedDateTimeLike | string;
  actor: Actor;
  stepActivationId: StepActivationId;
}

export interface FormSubmission extends SerializedFormSubmission {
  submittedAt: Temporal.ZonedDateTime;
}

export function reviveFormSubmission(serialized: SerializedFormSubmission): FormSubmission {
  return {
    ...serialized,
    submittedAt: Temporal.ZonedDateTime.from(serialized.submittedAt),
  };
}
